import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as CartActions from '../actions/cart-state.actions';
import { CartQueueItem, CartState, initialCartState } from '../state';

const reducer: ActionReducer<CartState, Action> = createReducer(
  initialCartState,
  on(CartActions.setCartId, (state, { id }) => ({
    ...state,
    cartId: id,
  })),
  on(CartActions.loadCartId, (state) => ({
    ...state,
    status: 'loading',
  })),
  on(CartActions.loadCartIdSuccess, (state, { id }) => ({
    ...state,
    cartId: id,
    error: null,
    status: 'success',
  })),
  on(CartActions.loadCartIdFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error',
  })),

  on(CartActions.setCart, (state, { cartData }) => ({
    ...state,
    cartData: cartData,
  })),
  on(CartActions.loadCart, (state) => ({
    ...state,
    status: 'loading',
  })),
  on(CartActions.loadCartSuccess, (state, { cartData }) => ({
    ...state,
    cartData: cartData,
    error: null,
    status: 'success',
  })),
  on(CartActions.loadCartFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error',
  })),
  on(CartActions.addToCartQueue, (state, { payload }) => {
    const cartQueue: CartQueueItem[] = [...state.cartQueue];

    const index: number = cartQueue.findIndex((item) => item.id === payload.id);

    if (index === -1) {
      cartQueue.push(payload);
    }

    return {
      ...state,
      cartQueue,
    };
  }),
  on(CartActions.cartActionSuccess, (state, { queueItem }) => {
    return {
      ...state,
      cartQueue: state.cartQueue.filter(item => item.id !== queueItem.id),
    };
  }),
  on(CartActions.cartActionFailure, (state, { queueItem }) => ({
    ...state,
    cartQueue: state.cartQueue.filter(item => item.id !== queueItem.id),
  })),
  on(CartActions.processCartQueue, (state) => ({
    ...state,
    isCartQueueProcessing: true,
  })),
  on(CartActions.cartQueueFinished, (state) => ({
    ...state,
    isCartQueueProcessing: false,
  })),
);

export function cartStateReducer(state: CartState | undefined, action: Action): CartState {
  return reducer(state, action);
}
